import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import logo from "../airlyze_logo.png";
import { showPopupSnackbar } from "../redux/actions/snackbarActions";
import { getToken } from "../Utils/Common";
import EnvSettings from "../Utils/EnvSettings";
import { useStyles } from "../Utils/Styles";
const server = EnvSettings.server;

export default function Devices(props) {
  const classes = useStyles();
  const [devicesList, setDevicesList] = useState();
  const [searchList, setSearchList] = useState();
  const dispatch = useDispatch();
  const history = useHistory();

  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  let getDevicesData = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: getToken() }),
    };
    fetch(server + "/get_devices", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          setSearchList(result.devices);
          setDevicesList(result.devices);
        }
      });
  };

  useEffect(getDevicesData, []);

  return (
    <Grid container spacing={3}>
      {devicesList
        ? searchList.map((row) => (
            <Grid key={row.id} item xs={12} sm={6} md={3}>
              <Paper
                onClick={() => {
                  history.push("/devices/" + row.id);
                }}
                className={fixedHeightPaper}
              >
                <Typography component="h1" variant="h6">
                  {row.deviceType === 1 ? "Medibag" : "Sensor Module"}
                </Typography>
                <Typography>{row.serialNumber}</Typography>
                <Typography>{row.deviceName}</Typography>
                <img alt={"Logo"} src={logo} style={{ width: 100 }} />
              </Paper>
            </Grid>
          ))
        : undefined}
    </Grid>
  );
}
